import React from "react";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import EditorFormSection from "../../EditorFormSection";
import Select from "react-select";
import { COLORTYPES, COLORS } from "../../../utils/colors";

const VinylSection = ({ isOpen, togglePanel }, context) => {
  const { control } = useFormContext(); // Get control from react-hook-form

  // Prepare options for react-select
  const options = Object.keys(COLORTYPES).map((prod) => ({
    value: COLORTYPES[prod],
    label: `${context.t(prod)} (${COLORS[COLORTYPES[prod]].length} ${context.t(
      "Colors"
    )})`,
  }));

  return (
    <EditorFormSection
      help={context.t("FileEditor.materialType.help")}
      panelName="vinyl"
      panelTitle={context.t("Please choose your type of vinyl")}
      open={isOpen}
      toggle={togglePanel}
    >
      <Controller
        name="materialSerie"
        control={control}
        defaultValue={options[0].value} // Default value is an integer
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            onChange={(selectedOption) => field.onChange(selectedOption.value)} // Store only the integer in the state
            value={
              options.find((option) => option.value === field.value) || null
            } // Display the correct label
          />
        )}
      />
    </EditorFormSection>
  );
};

VinylSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
};

VinylSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default VinylSection;
